<button type="button"
        class="dot-container"
  khA11yCarouselDot
  [khA11yCarouselDotActive]="isActive$ | async"
  [khA11yCarouselDotIndex]="index">
  <span class="dot" khA11yHidden [class.active]="isActive$ | async" [style.width.px]="dotDiameter" [style.height.px]="dotDiameter" [style.background]="(isActive$ | async) ? dotActiveColour : dotInactiveColour">
  </span>
</button>